// extracted by mini-css-extract-plugin
export default {"root":"Page_root__6puOo","outlet":"Page_outlet__PYXuZ","footer":"Page_footer__+u0mg"};